import {
  ADMIN_NOTIFICATIONS_REQUEST,
  ADMIN_NOTIFICATIONS_SUCCESS,
  ADMIN_NOTIFICATIONS_FAILURE,
  MARK_ADMIN_NOTIFICATION_READ_SUCCESS,
  MARK_ALL_ADMIN_NOTIFICATIONS_READ_SUCCESS,
  DISMISS_ADMIN_NOTIFICATION_TOAST
} from '../../actions/adminNotificationActions'
import { WS_MESSAGE } from '../../actions/wsActions'

export const initialState = {
  items: [],
  unreadCount: 0,
  loading: false,
  error: null,
  activeToast: null
}

export default function adminNotificationReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ADMIN_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case ADMIN_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        items: action.data.results || [],
        unreadCount: action.data.unread_count || 0,
        loading: false,
        error: null
      }

    case ADMIN_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    case MARK_ADMIN_NOTIFICATION_READ_SUCCESS: {
      const updatedItem = action.data
      const nextItems = state.items.map(item =>
        item.id === updatedItem.id
          ? { ...item, ...updatedItem, is_read: true }
          : item
      )
      return {
        ...state,
        items: nextItems,
        unreadCount: Math.max(0, state.unreadCount - 1)
      }
    }

    case MARK_ALL_ADMIN_NOTIFICATIONS_READ_SUCCESS:
      return {
        ...state,
        items: state.items.map(item => ({ ...item, is_read: true })),
        unreadCount: 0
      }

    case WS_MESSAGE: {
      if (
        action.data &&
        action.data.stream === 'notification' &&
        action.data.payload
      ) {
        const payload = action.data.payload
        // Prevent duplicate if already present in items
        const exists = state.items.some(
          x => x.id === payload.id || x.notification_id === payload.id
        )
        if (exists) return state

        const newItem = {
          id: payload.id,
          notification_id: payload.id,
          category: payload.category,
          event_type: payload.event_type,
          severity: payload.severity,
          title: payload.title,
          message: payload.message,
          target_route: payload.target_route,
          metadata: payload.metadata || {},
          city_id: payload.city_id,
          created_at: payload.created_at,
          is_read: false
        }

        return {
          ...state,
          items: [newItem, ...state.items],
          unreadCount: state.unreadCount + 1,
          activeToast: newItem
        }
      }
      return state
    }

    case DISMISS_ADMIN_NOTIFICATION_TOAST:
      return {
        ...state,
        activeToast: null
      }

    default:
      return state
  }
}
